function sendEvent(category, action, name, value = null) {
  if (typeof _paq !== "undefined") {
    _paq.push(["trackEvent", category, action, name, value]);
  } else {
    console.warn("Matomo (_paq) is not defined.");
  }
}

function sendClick(element, category, name) {
  if (element) {
    element.addEventListener("click", () => {
      sendEvent(category, "Click", name);
    });
  }
}

// AB Test Start
let variant = localStorage.getItem("ab-test");
if (!variant) {
  variant = Math.random() < 0.5 ? "A" : "B";
  localStorage.setItem("ab-test", variant);
}

const productName = document.querySelector('h1')?.textContent?.trim() || 'unknown_product';
const label = `${productName} | sosh`;

document.querySelectorAll('.vgrid__card').forEach((card) => {
  card.addEventListener('click', () => sendEvent('Science Cards', 'Open Theather', label), { once: true });
});

document.querySelectorAll('.lineup__tab').forEach((card) => {
  card.addEventListener('click', () => sendEvent('Collection Page Tabs', 'Switch Tab', label), { once: true });
});

document.addEventListener('atc:added', (e) => {
  const mainItem =
    e.detail.items.find((it) => String(it.variant_id) === String(e.detail.mainVariantId)) ||
    e.detail.items[0];

  sendEvent('ATC', 'Add To Cart', mainItem?.product_title || 'unknown_product');
});

